import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader';
import CONSTANTS from '../../constants';

const { GCPCERTS_API_URL } = CONSTANTS;

export type GcpCertReopenRequest = { gcpCertID: string; action: 'REOPEN' };

const reopenCert = async (request: GcpCertReopenRequest): Promise<any> => {
  const response = await fetchWithAuthorizationHeader(`${GCPCERTS_API_URL}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      action: 'REOPEN',
    },
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(`Failed to reopen certificate: ${message}`);
  }

  return response.json();
};

export default reopenCert;
